import React, { useMemo } from 'react';
import { UniqueVisitor } from 'sb-lib/types';
import { Icon } from 'shared/components/Icon';

import './style.less';
import { SpotlightAccount, SpotlightContact } from 'types/spotlight';

export const SpotlightSocials: React.FC<{
  visitor?: UniqueVisitor;
  account?: SpotlightAccount;
  contact?: SpotlightContact;
}> = ({ visitor, account, contact }) => {
  const query = useMemo(() => {
    if (visitor) {
      return encodeURI(
        `${visitor?.contact?.name ?? ''} ${visitor?.company?.name ?? ''}`.trim(),
      );
    }

    if (contact) {
      return encodeURI(`${contact?.name ?? ''} ${contact?.company?.name ?? ''}`.trim());
    }

    if (account) {
      return encodeURI(`${account?.name ?? ''} ${account?.domain ?? ''}`.trim());
    }
  }, [visitor, contact, account]);

  const googleLink = `https://www.google.com/search?q=${query}`;
  const linkedInLink = useMemo(() => {
    if (visitor || contact) {
      return `https://www.linkedin.com/search/results/people?keywords=${query}`;
    }

    if (account && account.clearbitData?.linkedin?.handle) {
      return `https://www.linkedin.com/${account.clearbitData?.linkedin?.handle}`;
    }

    if (account) {
      return `https://www.linkedin.com/search/results/companies?keywords=${query}`;
    }
  }, [visitor, contact, account, query]);

  if ((!visitor || !visitor?.displayName) && !account && (!contact || !contact?.name))
    return <></>;

  return (
    <div className="SpotlightSocials">
      <a
        href={linkedInLink}
        rel="noreferrer"
        className="SpotlightSocials__item"
        target="_blank"
      >
        <Icon width={12} height={12} icon="linkedinFilled" />
      </a>
      <a
        href={googleLink}
        className="SpotlightSocials__item"
        target="_blank"
        rel="noreferrer"
      >
        <Icon width={12} height={12} icon="google" />
      </a>
    </div>
  );
};
